import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const getShippingUserId = createAction(ACTION.GET_SHIPPING_USER_ID, data => data);

export const editShippingUser = createAction(ACTION.EDIT_SHIPPING_USER.REQUEST, data => data)
